import React, {Component} from "react";
import CdmLayout from "./../../../templates/cdm";
import {NavLink} from "react-router-dom";
import _ from "lodash";
import directoryList from "./../../json/users";
import * as moment from "moment";

export class PersonsDirectoryEdit extends Component {
	render() {
		const user = _.find(directoryList.data, {id: _.toInteger(this.props.match.params.id)});
		console.log('USER', user);
		return (<div className="columns is-centered">
			<div className="column is-10">
				<form id="process-form">
					<div className="field is-grouped">
						<div className="control is-expanded">
							<label htmlFor="name" className="label">Nombre</label>
							<input type="text" className="input" name="name" id="name" value={user.name} />
						</div>

						<div className="control is-expanded">
							<label htmlFor="last_name" className="label">Nombre</label>
							<input type="text" className="input" name="last_name" id="last_name" value={user.last_name} />
						</div>

						<div className="control is-expanded">
							<label htmlFor="slast_name" className="label">Nombre</label>
							<input type="text" className="input" name="slast_name" id="slast_name" value={user.slast_name} />
						</div>
					</div>

					<div className="field is-grouped">
						<div className="control is-expanded">
							<label htmlFor="job" className="label">Ocupación</label>
							<input type="text" className="input" id="job" name="job" value={user.job} placeholder="Ocupación" />
						</div>

						<div className="control is-expanded">
							<label htmlFor="code" className="label">Clave</label>
							<input type="text" name="code" id="code" className="input" value={user.code} placeholder="Clave de usuaria/o" />
						</div>

						<div className="control">
							<label htmlFor="type" className="label">Tipo</label>
							<div className="select">
								<select name="type" id="type">
									<option value="0" selected disabled>--- Tipo ---</option>
									<option value="1">Mujer líder</option>
									<option value="2" selected>Actor/a social</option>
								</select>
							</div>
						</div>

						<div className="control">
							<label htmlFor="polygon" className="label">Polígono</label>
							<div className="select">
								<select name="polygon" id="polygon">
									<option value="0" selected disabled>--- Polígono ---</option>
									<option value="1">Zona 1</option>
									<option value="2" selected>Zona 2</option>
								</select>
							</div>
						</div>
					</div>

					<div className="field is-grouped">
						<div className="control is-expanded">
							<label htmlFor="represents" className="label">Representa a</label>
							<input type="text" className="input" id="represents" name="represents" placeholder="Representa a" value={user.represents} />
						</div>

						<div className="control is-expanded">
							<label htmlFor="influence" className="label">Zona de influencia</label>
							<input type="text" className="input" name="influence" id="influence" placeholder="Zona de influencia" value={user.influence} />
						</div>
					</div>

					<hr/>

					<h6 className="title is-5">Domicilio</h6>

					<div className="field is-grouped">
						<div className="control is-expanded">
							<label htmlFor="address" className="label">Calle y número</label>
							<input type="text" id="address" name="address" className="input" placeholder="Calle y número" value={user.address} />
						</div>

						<div className="control is-expanded">
							<label htmlFor="address2" className="label">Colonia / Localidad</label>
							<input type="text" id="address2" name="address2" className="input" placeholder="Colonia / Localidad" value={user.address2} />
						</div>
					</div>

					<div className="field is-grouped">
						<div className="control">
							<label htmlFor="zipcode" className="label">Código postal</label>
							<input type="text" name="zipcode" id="zipcode" className="input" placeholder="Código postal" value={user.zipcode} />
						</div>
						<div className="control is-fullwidth">
							<label htmlFor="state" className="label">Estado</label>
							<div className="select">
								<select name="state" id="state">
									<option value="0" selected disabled>--- Estado ---</option>
									<option value="AGS">Aguascalientes</option>
									<option value="BCN">Baja California</option>
									<option value="BCS">Baja California Sur</option>
									<option value="CAM">Campeche</option>
									<option value="CHP">Chiapas</option>
									<option value="CHH">Chihuahua</option>
									<option value="COA">Coahuila de Zaragoza</option>
									<option value="COL" selected>Colima</option>
									<option value="CMX">Distrito Federal</option>
									<option value="DUR">Durango</option>
									<option value="GUA">Guanajuato</option>
									<option value="GRO">Guerrero</option>
									<option value="HID">Hidalgo</option>
									<option value="JAL">Jalisco</option>
									<option value="MIC">Michoacán de Ocampo</option>
									<option value="MOR">Morelos</option>
									<option value="MEX">México</option>
									<option value="NAY">Nayarit</option>
									<option value="NLE">Nuevo León</option>
									<option value="OAX">Oaxaca</option>
									<option value="PUE">Puebla</option>
									<option value="QTO">Querétaro</option>
									<option value="QRO">Quintana Roo</option>
									<option value="SLP">San Luis Potosí</option>
									<option value="SIN">Sinaloa</option>
									<option value="SON">Sonora</option>
									<option value="TAB">Tabasco</option>
									<option value="TAM">Tamaulipas</option>
									<option value="TLA">Tlaxcala</option>
									<option value="VER">Veracruz de Ignacio de la Llave</option>
									<option value="YUC">Yucatán</option>
									<option value="ZAC">Zacatecas</option>
								</select>
							</div>
						</div>

						<div className="control">
							<label htmlFor="municipality" className="label">Municipio</label>
							<div className="select">
								<select id="municipality">
									<option disabled="">--- Municipios ---</option>
									<option value="coquimatlan-74">Coquimatlán</option>
									<option value="manzanillo-77">Manzanillo</option>
									<option value="minatitlan-78">Minatitlán</option>
									<option value="tecoman-79">Tecomán</option>
									<option value="villa-de-alvarez-80" selected>Villa de Álvarez</option>
								</select>
							</div>
						</div>
					</div>

					<div className="field is-grouped">
						<div className="control is-expanded">
							<label htmlFor="phone" className="label">Teléfono</label>
							<input type="tel" id="phone" name="phone" className="input" placeholder="Teléfono" value={user.phone} />
						</div>

						<div className="control is-expanded">
							<label htmlFor="email" className="label">E-mail</label>
							<input type="email" id="email" name="email" className="input" placeholder="E-mail" value={user.email} />
						</div>
					</div>

					<div className="colmuns no-margin">
						<div className="column">
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<NavLink className="button is-large" to="/cdm/planeacion">Regresar</NavLink>
								</div>
								<div className="control">
									<button onClick={() => console.log(this.state)} className="button is-cdm-blue is-large" type="button">Guardar</button>
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>);
	}

	constructor() {
		super();
		this.state = {
			start_date: moment('2018-09-10'),
			end_date: moment('2018-09-21'),
			objective: 'Conocer el universo de programas, servicios y recursos públicos disponibles a nivel municipal, estatal y nacional, particularmente dirigidos a las mujeres.',
			rules: '<p>Cada que se requiera, verificar que la información de las instituciones, programas y servicios siga vigente; en caso contrario se complementará y/o actualizará.</p> <p>Integrar al catálogo de instituciones, todos aquellos programas y servicios nuevos que se identifiquen.</p>',
			report: '<p>Programs y servicios disponibles para las mujeres en el municipio.</p><ul><li>Descripción general</li><li>Dirección</li><li>Responsables: nombre completo, cargo, número de teléfono y cuenta de correo</li><li>Requisitos para participar</li></ul>',
			step1: '<p>Revisar el mapa del municipio reconociendo sus características y lo dividirá en polígonos que le permitan trabajar en zonas más pequeñas, programar recorridos y actividades en cada uno.</p>'
		}
	}
}

export default CdmLayout(PersonsDirectoryEdit, {
	title: 'Editar persona',
	subnav: {
		icon: 'fa-user',
		name: 'Editar persona',
		actions: [
		]
	},
	stateNav: true,
	progress: true
});


// WEBPACK FOOTER //
// ./src/cdm-frontend/pages/directory/edit.jsx